var _circle, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPackage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#001EFF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2436_4703)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.2114 10L20.686 10.031L29.8007 14.5116C30.1242 14.6759 30.4042 14.8986 30.3598 15.312L30.2964 26.0543L29.674 26.5595L20.4059 31L10.9366 26.4218L10.5154 26.0532L10.4509 25.6604C10.6821 22.3637 10.1664 18.6777 10.452 15.428C10.5354 14.4852 11.3801 14.3222 12.1214 13.9375C14.7832 12.5584 17.5451 11.3699 20.2114 10ZM17.9052 12.3919L18.3465 12.7961L25.6563 16.3903C25.8985 16.4281 28.2414 15.281 28.2392 15.0892L20.4904 11.2608L17.9052 12.3919ZM22.7899 17.5638L15.1533 13.9008C14.6832 13.8169 13.1139 14.863 12.5715 15.0881C12.5693 15.2489 13.5596 15.7197 13.7518 15.8184C15.9213 16.9242 18.1642 17.8968 20.3381 18.9957C20.4937 19.0095 22.6732 18.0208 22.7443 17.906C22.7977 17.8187 22.8321 17.6293 22.7899 17.5627V17.5638ZM19.7946 29.3843V20.1406L11.9313 16.2031C11.8113 16.1078 11.569 16.2777 11.569 16.3512V25.3079L19.7935 29.3843H19.7946ZM21.0172 29.3843L29.2417 25.3079V16.3512C29.2417 16.2306 29.0216 16.1732 28.8794 16.2031C28.267 16.3328 27.2723 17.1791 26.5921 17.3456L26.5554 22.3614L23.7957 23.6429V18.82L21.0172 20.1406V29.3843Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2436_4703"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 21,
    fill: "white",
    transform: "translate(10.3643 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPackage);
export default __webpack_public_path__ + "static/media/package.cf09c23a724dd3b1ce5c808a9b47c764.svg";
export { ForwardRef as ReactComponent };